import styled from 'styled-components';
import { SIDEBAR_COL_WIDTH } from '../../../life-id/life-id.styled';

export const CalendarDayViewSC = styled.div`
  .calendar-day-container {
    position: relative;
    width: ${SIDEBAR_COL_WIDTH}px;
    height: 90vh;
    overflow: scroll;
    overflow-x: hidden;
  }
`;
